import React from "react";
import { ComplianceDashboardPage } from "../../features/compliance/presentation/pages/ComplianceDashboardPage";

const ComplianceSection: React.FC = () => {
  return <ComplianceDashboardPage />;
};

export default ComplianceSection;

